import React from 'react';
import {Prompt} from 'react-router-dom';
import { Toast, Button, Modal } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import api from './api';
import './index.less';

class safetyTrainingCoursesIndex extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            detailData: {
                courseUrl: []
            },
            second: 0,
            exitvisible:false,
        };
    }

    // #/safetyTrainingCoursesIndex?app_stoken=xxxx&questionBankCode=xxx&linkCode=xxx&activityCode=xxxx
    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                const {urlOps} = this.state;
                if(urlOps.linkCode){
                    this.getDetail1()
                }else{
                    this.getDetail()
                }
            });
        }
    }
    componentWillUnmount(){
        this.timer && clearTimeout(this.timer);
    }

    // 获取随机课程
    getDetail(){
        this.timer && clearTimeout(this.timer)
        const {urlOps} = this.state;
        post({
            url: api.createCourse + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                questionBankCode: urlOps.questionBankCode,
                activityCode: urlOps.activityCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                localStorage.setItem('isPrompt',true)//离开
                this.setState({
                    detailData: {
                        ...res.data,
                        courseUrl: res.data.courseType == 1 ? res.data.courseUrl || '' : res.data.courseUrl ? res.data.courseUrl.split(',') : []
                    },
                    second: res.data.courseDuration,
                },()=>{
                    const {detailData} = this.state;
                    var _this = this
                    if(detailData.courseType == 1){
                        let KCvideo = document.getElementById('KCvideo')
                        KCvideo.addEventListener('play', () => { //播放开始执行的函数
                            const {second} = _this.state;
                            if(second > 0){
                                _this.secondHeadel()
                            }
                        });
                        KCvideo.addEventListener('pause', () => { //暂停开始执行的函数
                            _this.timer && clearTimeout(_this.timer);
                        }); 
                    }else{
                        this.secondHeadel()
                    }
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取课程详情失败',1);
        });
    }
    secondHeadel(){
        let { second } = this.state
        if(second<=0){
            clearTimeout(this.timer)
            this.submit()
        }else{
            this.setState({
                second: second -= 1
            },()=>{
                this.timer = setTimeout(() => {
                    this.secondHeadel()
                },1000)
            })
        }
    }
    submit(){
        localStorage.setItem('isPrompt',false)//离开

        const {urlOps, detailData} = this.state;
        post({
            url: api.commitCourse + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                courseCode: detailData.courseCode,
                duration: detailData.courseDuration,
                activityUserPrizeCode: urlOps.activityUserPrizeCode,
                activityCode: urlOps.activityCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                Toast.info('奖励已发放',1)
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('奖励发放失败',1);
        });
    }
    
    // 获取课程详情
    getDetail1(){
        const {urlOps} = this.state;
        post({
            url: api.selectCourseDetail + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                courseCode: urlOps.linkCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                localStorage.setItem('isPrompt',false)//离开
                this.setState({
                    detailData: {
                        ...res.data,
                        courseUrl: res.data.courseType == 1 ? res.data.courseUrl : res.data.courseUrl ? res.data.courseUrl.split(',') : []
                    },
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取课程详情失败',1);
        });
    }

    render() {
        const { urlOps, detailData, second, exitvisible } = this.state
        // console.log(urlOps)
        return (
            <div className="safetyTrainingCoursesIndexBox">
                {urlOps.linkCode ? '' : second > 0 ? (
                    <div className="tips-box">
                        温馨提示：需有效观看 <span className="text-warning">{second}秒</span> ，否则课程学习无效
                    </div>
                ) : (
                    <div className="tips-box">
                        课程学习已完成
                    </div>
                )}
                {
                    detailData.courseType == 1 ? (
                        // 视频类
                        <div className="videoBox">
                            <div>
                                <h1>{detailData.courseName}</h1>
                                <div className="videoContent">
                                    <video
                                        id="KCvideo"
                                        src={detailData.courseUrl}
                                        autoPlay
                                        controls
                                        muted
                                        // webkit-playsinline="true" /*IOS中让视频在小窗内播放而不是全屏播放*/  
                                        playsInline={true} /*IOS微信浏览器支持小窗内播放*/ 
                                        // x-webkit-airplay="allow" /*是否支持ios的AirPlay功能*/
                                        // x5-video-player-type="h5" /*启用H5播放器,是wechat安卓版特性*/
                                        style={{objectFit:'fill', width: '100%'}}
                                    ></video>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // 图文类
                        <div className="ImgTextBox">
                            <div>
                                <h1>{detailData.courseName}</h1>
                                <div className="ImgTextContent">
                                    {
                                        detailData.courseUrl.map((item,index)=>{
                                            return (<img src={item} key={index}/>)
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }
                
                <Prompt
                    when={true}
                    message={(location) =>{
                        if(localStorage.getItem('isPrompt') == 'false'){
                            return true
                        }else{
                            // window.location.replace(window.location.pathname+`#/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${urlOps.questionBankCode}&activityUserPrizeCode=${urlOps.activityUserPrizeCode}&activityCode=${urlOps.activityCode}`)
                            // href(`/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${urlOps.questionBankCode}&activityUserPrizeCode=${urlOps.activityUserPrizeCode}&activityCode=${urlOps.activityCode}`);

                            // 停止计时
                            this.timer && clearTimeout(this.timer);
                            if(detailData.courseType == 1){
                                document.getElementById('KCvideo').pause();
                            }
                            this.setState({exitvisible:true});
                            return false
                        }
                    }}
                />
                <Modal
                    visible={exitvisible}
                    transparent
                >
                    <div className='modalContent'>
                        <div className='title'>再学习<span className="textOrange">{ second }s</span>，可领奖励！</div>
                    </div>
                    <div className='orange'>
                        <Button color='primary' fill='solid' onClick={()=>{
                            localStorage.setItem('isPrompt',true)//离开
                            if(detailData.courseType == 1){
                                document.getElementById('KCvideo').play();
                            }
                            this.secondHeadel()
                            this.setState({
                                exitvisible:false,
                            });
                        }}>
                            继续学习
                        </Button>
                    </div>
                    <div className='text-center' style={{'lineHeight':'48px'}} onClick={()=>{
                        localStorage.setItem('isPrompt',false)//离开
                        if(window.location.href.indexOf('/peaceSharkIndex') > -1){
                            // window.location.reload()
                            href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}&time=${new Date().getTime()}`);
                        }else{
                            href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);
                        }
                    }}>坚持退出</div>
                </Modal>
                
                
            </div>
        );
    }
};

export default safetyTrainingCoursesIndex;


// WEBPACK FOOTER //
// ./src/safetyTrainingCourses/index/index.js